import { Component, Inject, InjectionToken, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { pluck } from 'rxjs/operators';
import { ConnectionService } from '../../services/connection-service/connection-service.service';

export const LOCATION_TOKEN = new InjectionToken<Location>('Window location object');

@Component({
    selector: 'reload-page',
    templateUrl: './reload-page.component.html',
    providers: [{ provide: LOCATION_TOKEN, useValue: window.location }]
})
export class ReloadPageComponent implements OnInit {
    public reloadRequired: Observable<boolean>;

    constructor(@Inject(LOCATION_TOKEN) private location: Location, private connectionService: ConnectionService) { }

    ngOnInit() {
        this.reloadRequired = this.connectionService.monitor()
            .pipe(pluck('OutOfDate'));
    }

    reloadPage() {
        this.location.reload();
    }
}
